import client from './client';

const Score = {
  getScore(anketId) {
    return client.get(`/ankets/${anketId}/score`);
  },
  forceUpdateScore(anketId) {
    return client.get(`/ankets/${anketId}/force_update_score`);
  },
};

export default Score;
